/* Product-card image swap, quantity stepper and accessible product information tabs. */
(()=>{
 'use strict';
 const readyImage=img=>{
  if(!(img instanceof HTMLImageElement)||!img.matches('.product-image-secondary'))return;
  img.closest('.product-image')?.classList.toggle('is-hover-ready',img.complete&&img.naturalWidth>0&&!img.currentSrc.startsWith('data:'));
 };
 document.querySelectorAll('.product-image-secondary').forEach(readyImage);
 document.addEventListener('load',e=>readyImage(e.target),true);
 document.addEventListener('error',e=>readyImage(e.target),true);
 function initialize(scope=document){
  scope.querySelectorAll('[data-product-tabs]').forEach(group=>{
   if(group.dataset.initialized)return;group.dataset.initialized='true';
   const list=group.querySelector('[data-product-tablist]'),tabs=[...group.querySelectorAll('[data-product-tab]')],panels=[...group.querySelectorAll('[data-product-panel]')];
   function activate(tab,focus=false){
    tabs.forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1});
    panels.forEach(p=>p.hidden=p.id!==tab.getAttribute('aria-controls'));
    if(focus){tab.focus({preventScroll:true});list.scrollTo({left:Math.max(0,tab.offsetLeft-list.offsetLeft-12),behavior:'instant'})}
   }
   list.setAttribute('role','tablist');list.hidden=false;
   tabs.forEach(t=>{t.setAttribute('role','tab');t.addEventListener('click',()=>activate(t))});
   panels.forEach(p=>{p.setAttribute('role','tabpanel');p.tabIndex=0;p.setAttribute('aria-labelledby',tabs.find(t=>t.getAttribute('aria-controls')===p.id).id)});
   list.addEventListener('keydown',e=>{
    const i=tabs.indexOf(e.target);if(i<0)return;let n;
    if(e.key==='ArrowRight')n=(i+1)%tabs.length;else if(e.key==='ArrowLeft')n=(i-1+tabs.length)%tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=tabs.length-1;else return;
    e.preventDefault();activate(tabs[n],true);
   });group.classList.add('is-tabs-ready');activate(tabs[0]);
  });
  scope.querySelectorAll('[data-quantity-control]').forEach(control=>{
   if(control.dataset.initialized)return;control.dataset.initialized='true';
   const input=control.querySelector('input'),minus=control.querySelector('[data-quantity-change="-1"]'),plus=control.querySelector('[data-quantity-change="1"]'),variant=control.closest('form').querySelector('[data-variant-select]');
   const minimum=()=>Number(input.min)||1,maximum=()=>input.max===''?Infinity:Number(input.max);
   function sync(){const value=input.valueAsNumber;minus.disabled=!Number.isFinite(value)||value<=minimum();plus.disabled=Number.isFinite(value)&&value>=maximum()}
   control.addEventListener('click',e=>{const button=e.target.closest('[data-quantity-change]');if(!button)return;
    if(!Number.isFinite(input.valueAsNumber))input.value=minimum();
    else if(Number(button.dataset.quantityChange)>0)input.stepUp();else input.stepDown();
    input.value=Math.min(maximum(),Math.max(minimum(),input.valueAsNumber));input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));
   });input.addEventListener('input',sync);input.addEventListener('change',sync);
   variant?.addEventListener('change',()=>{
    const option=variant.selectedOptions[0];input.min=option.dataset.quantityMin||'1';input.step=option.dataset.quantityStep||'1';input.max=option.dataset.quantityMax||'';
    const min=minimum(),step=Number(input.step)||1,current=input.valueAsNumber;
    input.value=Math.min(maximum(),Math.max(min,Number.isFinite(current)?min+Math.ceil((current-min)/step)*step:min));sync();
   });sync();
  });
  scope.querySelectorAll('.product-image-secondary').forEach(readyImage);
 }
 initialize();document.addEventListener('shopify:section:load',e=>initialize(e.target));document.addEventListener('catalog:updated',()=>initialize());
})();
